<div class="row">
  <div class="col-xs-12 col-md-4">
    <app-menudesktop (contratoenvio)="recibirContrato($event)"></app-menudesktop>
  </div>
  <div class="col-xs-12 col-md-8 scyr-interior">
    <alertbox
      [messageBox]="messageCabecera"
      [typeException]="typeException"
      [messageComplet]="messageComplet"
    ></alertbox>
    <section>
      <div class="contact-title-area">
        <h1>Contacte con nosotros</h1>
        <div class="tlf-contacto btn-default tlf-contacto__desktop">
          <p>Llámenos para cualquier consulta</p>
          <p class="tlf">
            <img
              src="assets/images/icons/llamanos-blue.svg"
              alt=""
            >
            <span>{{telefonoexplotacion}}</span>
          </p>
        </div>
        <a
          href="tel:{{telefonoexplotacion}}"
          class="btn-default tlf-contacto__mobile"
        >{{telefonoexplotacion}} </a>
      </div>
      <p>Si desea ponerse en contacto con nosotros puede rellenar este formulario y recibiremos un correo electrónico.
      </p>
      <div class="col-xs-12 box">
        <form
          class=""
          id="form"
          method="get"
          action=""
        >
          <h2 class="line">Consúltenos sus dudas</h2>
          <fieldset>
            <legend class="sr-only">Formulario datos solicitante</legend>
            <div
              class="row"
              *ngIf="!contratoSelected.Ficticio"
            >
              <div class="col-xs-12 col-sm-6 col-md-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'direccionSuministro'"
                  [setLabel]="'Dirección suministro'"
                  [setValue]="direccionSuministro"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="direccionSuministro = $event"
                ></sacyr-input>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'name'"
                  [setLabel]="'Nombre y apellidos'"
                  [setValue]="name"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="name = $event"
                ></sacyr-input>
              </div>
              <div class="col-xs-12 col-sm-6 col-md-6">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'email'"
                  [setLabel]="'Email'"
                  [setValue]="email"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="email = $event"
                ></sacyr-input>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-10">
                <p>{{avisoEmail}}</p>
              </div>
            </div>
            <div
              *ngIf="isEmmasa"
              class="row"
            >
              <div class="col-xs-12 col-sm-6 col-md-6">
                <div class="input-form input-select">
                  <label
                    for="tipo"
                    class="slct"
                  >Tipo</label>
                  <div class="select">
                    <select
                      name="tipo"
                      [(ngModel)]="tipo"
                    >
                      <option
                        value='-1'
                        selected
                      >Seleccione un tipo</option>
                      <option value='0'>Duda</option>
                      <option value='1'>Reclamacion</option>
                      <option value='2'>Otros</option>
                    </select>
                  </div>
                </div>
                <span
                  *ngIf="tipoInputError"
                  class="error"
                >Seleccione un tipo</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-6 col-md-10">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'asunto'"
                  [setLabel]="'Asunto'"
                  [setValue]="asunto"
                  [setRequired]="true"
                  (outValue)="asunto = $event"
                ></sacyr-input>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="input-form input-textarea">
                  <label for="consulta">CONSULTA:</label>
                  <textarea
                    name="consulta"
                    [(ngModel)]="consulta"
                  ></textarea>
                </div>
                <span
                  *ngIf="consultaInputError"
                  class="error"
                >Introduzca su consulta</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <div class="input-form input-check input-check__privacidad">
                  <input
                    type="checkbox"
                    id="agree"
                    [(ngModel)]="politicas"
                    name="agree"
                    required
                  />
                  <label for="agree"> He leído y acepto la
                    <a (click)="_showModalPolitica=true">Política de privacidad</a> de la Oficina Virtual de {{pie}}.
                  </label>
                </div>
                <span
                  *ngIf="politicasInputError"
                  class="error"
                >Acepte la política de privacidad</span>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">

                <sacyr-input
                  [setType]="'text'"
                  [setName]="'ubicacionOficina'"
                  [setLabel]="'Contacto'"
                  [setValue]="ubicacionOficina"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="ubicacionOficina = $event"
                ></sacyr-input>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-12">
                <sacyr-input
                  [setType]="'text'"
                  [setName]="'horario'"
                  [setLabel]="'Horario'"
                  [setValue]="horario"
                  [setRequired]="true"
                  [setReadOnly]="true"
                  (outValue)="horario = $event"
                ></sacyr-input>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
    </section>
    <div class="input-form input-button">
      <button
        type="submit"
        class="btn-default"
        (click)="enviar()"
      >Enviar</button>
    </div>

    <!-- MODAL -->
    <sacyr-modal
      [setTemplateRef]="modal_content"
      [showModal]="showModal()"
      (closeModal)="closeModal()"
    ></sacyr-modal>

    <ng-template #modal_content>

      <ng-container *ngIf="_showModalPolitica">
        <h1>Política de privacidad</h1>
        <div [innerHTML]="condicionesEnvio"></div>
      </ng-container>
    </ng-template>
